<template>
  <div class="matrix">
    <article
      v-for="(m, i) in modules"
      :key="m.name"
      class="mod card reveal"
      v-reveal="{ delay: (i % 3) * 90 }"
    >
      <header class="mod-head">
        <span class="mod-icon"><IconSvg :name="m.icon"/></span>
        <h3 class="mod-name">{{ m.name }}</h3>
        <span class="mod-count">{{ m.items.length }} 项</span>
      </header>
      <ul class="mod-list">
        <li v-for="(it, ii) in m.items" :key="ii">
          <IconSvg name="check"/>
          <span>{{ it }}</span>
        </li>
      </ul>
    </article>
  </div>
</template>

<script>
import IconSvg from './IconSvg'

export default {
  name: 'ModuleMatrix',
  components: { IconSvg },
  props: {
    modules: { type: Array, default: () => [] }
  }
}
</script>

<style lang="scss" scoped>
.matrix {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px;
}

.mod {
  padding: 26px 26px 24px;
  display: flex;
  flex-direction: column;

  &:hover .mod-icon {
    color: var(--accent-txt);
    border-color: var(--accent);
    box-shadow: 0 0 26px -8px var(--accent);
  }
}

.mod-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(120, 176, 255, 0.12);
}

.mod-icon {
  width: 40px;
  height: 40px;
  padding: 10px;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid var(--line-strong);
  color: var(--txt-2);
  background: rgba(255, 255, 255, 0.03);
  transition: all 0.4s;
}

.mod-name {
  flex: 1;
  font-size: 17px;
  color: #fff;
}

.mod-count {
  font-size: 12px;
  letter-spacing: 0.06em;
  color: var(--txt-3);
}

.mod-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 18px;

  li {
    display: flex;
    gap: 10px;
    font-size: 13.5px;
    line-height: 1.75;
    color: var(--txt-2);
  }

  svg {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
    margin-top: 5px;
    color: var(--accent-txt);
  }
}

@media (max-width: 1080px) {
  .matrix { grid-template-columns: minmax(0, 1fr); }
}
</style>
